import { render, staticRenderFns } from "./SpcmCounsellorAdd.vue?vue&type=template&id=053bf69f&scoped=true"
import script from "./SpcmCounsellorAdd.vue?vue&type=script&lang=js"
export * from "./SpcmCounsellorAdd.vue?vue&type=script&lang=js"
import style0 from "./SpcmCounsellorAdd.vue?vue&type=style&index=0&id=053bf69f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053bf69f",
  null
  
)

export default component.exports